
export default {

  computed:{
    sidebar_items(){
      return {
        'domain':{
          icon:'fa fa-at',
          "package":"domain",
          route_name:'domain-view',
          items:[
            {
              key:'create',
              icon:'fa fa-plus',
              logo:'test'
            },
            {
              icon:'fa fa-list',
              key:'list',
            },
            {
              icon:'fa fa-trash',
              key:'deleted'
            },
            {
              icon:'fa fa-id-badge',
              key:'handles'
            },
            {
              icon:'fa fa-server',
              key:'nameserver'
            },
            {
              icon:'fa fa-check',
              key:'setup'
            },
            {
              icon:'fa fa-money',
              key:'prices'
            },
          ]
        },
        dns:{
          icon:'fa fa-wifi',
          route_name:'dns-view',
          "package":"dns",
          items:[
            {
              key:'list'
            }
          ]
        },
        // ssl:{
        //   icon:'fa fa-key',
        //   route_name:'ssl-view',
        //   "package":"ssl",
        //   items:[
        //     {
        //       key:'order'
        //     },
        //   ]
        // },
        datacenter:{
          icon:'fa fa-tasks',
          route_name:'datacenter-view',
          "package":"datacenter",
          items:[
            {
              icon:'fa fa-plus',
              key:'order'
            },
            {
              icon:'fa fa-server',
              key:'vserver'
            },
            // {
            //   key:'dedicated',
            //   icon:'fa fa-laptop'
            // },
            // {
            //   key:'teamspeaker',
            //   icon:'fa fa-users'
            // }
          ]
        },
        // rz:{
        //   icon: 'fa fa-building',
        //   "package":"datacenter",
        //   items:[
        //     {
        //       key:'ddos'
        //     },
        //     {
        //       key:'ip'
        //     },
        //     {
        //       key:'installation'
        //     },
        //     {
        //       key:'operation'
        //     },
        //     {
        //       key:'traffic'
        //     },
        //     {
        //       key:'pools'
        //     }
        //   ]
        // },
        // licence:{
        //   icon:'fa fa-star',
        //   "package":"datacenter",
        //   items:[
        //     {
        //       key:'multicraft'
        //     }
        //   ]
        // },
        account:{
          "package":"account",
          icon:'fa fa-users',
          route_name:'account-view',
          items:[
            {
              key:'subuser',
              icon:'fa fa-user'
            },
            {
              key:'details',
              icon:'fa fa-info'
            },
            // {
            //   key:'task'
            // }
          ]
        },
        accounting:{
          icon:'fa fa-book',
          "package":"accounting",
          route_name:'accounting-view',
          items:[
            {
              key:'balance',
              icon:'fa fa-credit-card'
            },
            {
              key:'debit',
              icon:'fa fa-tag'
            },
            {
              icon:'fa fa-history',
              key:'bill'
            },
            {
              key:'open',
              icon:'fa fa-flag-checkered'
            },
            {
              key:'transaction',
              icon:'fa fa-exchange'
            },
          ]
        },
        // tools:{
        //   "package":"tools",
        //   icon:'fa fa-cogs',
        //   items:[
        //     {
        //       key:'list',
        //     }
        //   ]
        // },
        // support:{
        //   "package":"support",
        //   icon:'fa fa-question',
        //   items:[
        //     {
        //       key:'list'
        //     }
        //   ]
        // }
      }
    },
    items(){
      // if (MainSidebar) {return MainSidebar}

      const base = Object.keys(this.sidebar_items).map((el,index)=>({
            visible:false,
            key: el,
            icon:this.sidebar_items[el]['icon'],
            toggle: 'collapse-'+el,
            component: 'MainView',
            route_name: el +'-view',
            'package': this.sidebar_items[el]['package'],
            items:this.sidebar_items[el]['items'].map(i=>(
              {
                visible:false,
                key:i.key,
                label:i.key,
                icon:i.icon || 'fa fa-plus',
                component : this.sidebar_items[el]['package'] !== el
                  ? this.capitalizeString(this.sidebar_items[el]['package']) +this.capitalizeString(el) + this.capitalizeString(i.key)
                  : this.capitalizeString(this.sidebar_items[el]['package'])  + this.capitalizeString(i.key),

                route: this.sidebar_items[el]['package'] !== el
                  ? this.sidebar_items[el]['package'] +'-'+el+ '-' +i.key
                  : this.sidebar_items[el]['package'] + '-' + i.key,

                route_path: this.sidebar_items[el]['package'] !== el
                  ? '/'+ this.sidebar_items[el]['package'] +'/'+el+ '/' +i.key
                  : '/'+ this.sidebar_items[el]['package'] + '/' + i.key
              }
                // component:this.sidebar_items[el]['package']+this.sidebar_items[el]['key']}
              )
            )
            // ...this.sidebar_items[el]
          }
        )
      )
      return base
      return  base.map((el)=>({
        'key':el.key,
        'route_name': el.key + '-view',
        'package':el.package,
        'items':el.items,
        // 'label':this.$t('sidebar')[el.key]['label'],
        'toggle': 'collapse-'+el.key,
        'icon':el.icon,
        'component':el.component,
        'visible':false
      }))

    },
    current_route_package(){
      return this.$route.meta.package
    },
    current_route_key(){
      return this.$route.meta.key
    },
    current_route_name() {
      const x = this.$route.name.split('-')
      return x
    }
  },
  methods:{
    capitalizeString(str){
      const res = str.substr(0, 1).toUpperCase() + str.substr(1).toLowerCase()
      return res
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/main_sidebar.js